/**
 * Нормалізація тегів на клієнті.
 *
 * Дзеркалить functions/_shared/tags.js: користувач пише "#Математика, Наголоси",
 * а в базі лежить "математика", "наголоси". Тримаємо правила в одному місці,
 * щоб фільтри в UI й у запитах збігалися.
 */

const MAX_TAG_LEN = 48

/** Прибирає '#', пробіли, спецсимволи; обрізає; повертає null для порожніх. */
export function normalizeTag(raw) {
  if (raw === null || raw === undefined) return null
  const cleaned = String(raw)
    .trim()
    .replace(/^#+/, '')
    .replace(/\s+/g, '_')
    .replace(/[^\p{L}\p{N}_/+-]/gu, '')
    .slice(0, MAX_TAG_LEN)
    .replace(/^_+|_+$/g, '')
  return cleaned.length ? cleaned.toLowerCase() : null
}

/** Приймає масив або рядок "математика, наголоси #дати" → масив унікальних тегів. */
export function parseTagInput(input, { max = 24 } = {}) {
  if (!input) return []
  const list = Array.isArray(input) ? input : String(input).split(/[,\s]+/)
  const out = new Set()
  for (const item of list) {
    const t = normalizeTag(item)
    if (t) out.add(t)
  }
  return [...out].slice(0, max)
}

/** Рядок тегів із D1 (GROUP_CONCAT) → масив. */
export function splitTagList(tagList) {
  if (!tagList) return []
  return String(tagList)
    .split(/[\s,]+/)
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean)
}

/** Теги у вигляді «#a, #b» для відображення. */
export const formatTagList = (tags) => (tags ?? []).map((t) => `#${t}`).join(', ')
